import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cm-confirm-reload',
  templateUrl: './confirm-reload.component.html',
  styleUrls: ['./confirm-reload.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ConfirmReloadComponent {
  onConfirm() {
    window.location.reload();
  }
}
